// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/api-paging-request-schema',
  type: 'object',
  required: ['currentPage', 'pageSize'],
  properties: {
    currentPage: {
      type: 'integer',
    },
    pageSize: {
      type: 'integer',
    },
    includeCount: {
      type: 'boolean',
    },
    noPaging: {
      type: 'boolean',
    },
  },
} as IJSONSchema;

export default schema;
